module.exports = __webpack_public_path__ + "fonts/font01-Regular.4a02a322.woff2";